import Modal from './Modal';

class WishList {
  constructor() {
    this.settings = {
      addWishListBtn: '.js-add-wishlist-btn',
      wishListBtn: '.js-open-wishlist-btn',
      addSuccessModal: 'wishlist-added',
      wishListModal: 'wishlist-request',
      emptyCartModal: 'wishlist-empty',
      removeFromWishListBtn: '.cart__delete',
      formId: '7746',
    };
    this.modal = new Modal();
  }

  init() {
    this.initListeners();
  }

  initListeners() {
    const $this = this;
    $('body').on('click', this.settings.addWishListBtn, (e) => {
      e.preventDefault();
      const $element = $(e.currentTarget);
      const id = $element.data('id');
      if (!$element.hasClass('active')) {
        $this.addToWishList(id, $element);
      } else {
        $this.removeFromWishList(id, $element);
      }
    });
    $('body').on('click', this.settings.wishListBtn, (e) => {
      e.preventDefault();
      $this.openWishList();
    });
    $('body').on('click', this.settings.removeFromWishListBtn, (e) => {
      e.preventDefault();
      const id = $(e.target).data('id');
      const element = $(`*[data-id=${id}]`);
      this.removeFromWishList(id, element);
    });

    document.addEventListener('wpcf7mailsent', (event) => {
      if ($this.settings.formId === event.detail.contactFormId) {
        if (window.gtag) {
          window.gtag('event', 'BucketList', {
            event_category: 'ContactForm',
            event_label: 'FormComplete',
          });
        }
        $this.clearWishlist();
      }
      if (event.detail.contactFormId === '7747') {
        if (window.gtag) {
          window.gtag('event', 'Sent', {
            event_category: 'Form',
            event_label: 'TelephoneAppointment',
          });
        }
      }
      if (event.detail.contactFormId === '118') {
        window.location = '/thank-you/';
      }
    }, false);
  }

  static toggleActiveElement(element) {
    element.toggleClass('active');
  }

  addToWishList(id, element) {
    const $this = this;
    if (!id) {
      console.log('Missing ID');
      return;
    }
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        id,
        action: 'add_to_wishlist',
      },
      success(response) {
        if (response.success) {
          $this.constructor.toggleActiveElement(element);
          $this.constructor.updateCounter(response.data);
          $this.modal.openModal($(`#${$this.settings.addSuccessModal}`));
          $this.constructor.sendEvent();
        }
      },
      error(response) {
        console.log('error', response);
      },
    });
  }

  static sendEvent() {
    if (!window.gtag) {
      return;
    }
    window.gtag('event', 'Clicked', {
      event_category: 'Added',
      event_label: 'WishList',
    });
  }

  clearWishlist() {
    const $this = this;
    const modal = $(`#${this.settings.wishListModal}`);
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'clear_wishlist',
      },
      success(response) {
        if (response.success) {
          $this.constructor.clearModalBody(modal);
          $this.constructor.updateCounter(response.data);
          modal.find('input').attr('disabled', true);
          if (response.data) {
            response.data.map((post) => {
              $this.constructor.addCartItem(post, modal);
              return post;
            });
          }
        }
      },
      error(response) {
        console.log('error', response);
      },
    });
  }

  static updateCounter(data) {
    const star = $('header .wishlist__button');
    const counter = star.find('.counter');
    if (data) {
      if (!counter.hasClass('active')) {
        counter.addClass('active');
      }
      counter.html(data.length);
    } else {
      counter.removeClass('active');
      counter.html(0);
    }
  }

  removeFromWishList(id, element) {
    const $this = this;
    const modal = $(`#${this.settings.wishListModal}`);
    if (!id) {
      console.log('Missing ID');
      return;
    }
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        id,
        action: 'remove_from_wishlist',
      },
      success(response) {
        if (response.success) {
          $this.constructor.clearModalBody(modal);
          $this.constructor.toggleActiveElement(element);
          $this.constructor.updateCounter(response.data);
          if (!response.data) {
            $this.modal.closeModal(modal);
          }
          if (response.data) {
            response.data.map((post) => {
              $this.constructor.addCartItem(post, modal);
              return post;
            });
          }
        }
      },
      error(response) {
        console.log('error', response);
      },
    });
  }

  openWishList() {
    const modal = $(`#${this.settings.wishListModal}`);
    this.modal.closeModal($(`#${this.settings.addSuccessModal}`));
    if (!modal) {
      console.log('Missing WishListModal');
      return;
    }
    this.loadDataToModal(modal);
  }

  loadDataToModal(modal) {
    this.constructor.getWishListData().then((data) => {
      if (!data) {
        this.modal.openModal($(`#${this.settings.emptyCartModal}`));
        return;
      }
      this.constructor.clearModalBody(modal);
      data.map((post) => {
        this.constructor.addCartItem(post, modal);
        return post;
      });
      this.modal.openModal(modal);
    });
  }

  static clearModalBody(modal) {
    modal.find('.wishlist__cart').html('');
    modal.find('#wishlist').text('');
  }

  static addCartItem(post, modal) {
    const $template = `<div class="cart__item">
        <span class="number">${post.number}</span>
        <a href="${post.link}" class="item__name">${post.name}</a>
        <button type="button" class="cart__delete" data-id="${post.id}"></button>`;
    modal.find('.wishlist__cart').append($template);
    const text = modal.find('#wishlist').text();
    modal.find('#wishlist').text(`${text} ${post.name} - id: ${post.id} \r\n`);
  }

  static getWishListData() {
    return new Promise((resolve) => {
      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'GET',
        dataType: 'json',
        data: {
          action: 'get_wishlist_data',
        },
        success(response) {
          if (response.success) {
            resolve(response.data);
          }
          return [];
        },
        error(response) {
          console.log('error', response);
          return [];
        },
      });
    });
  }
}

export default WishList;
